import { prepareHeaders } from "./";
import cincolabdataEndpoints from "./cincolabdata.endpoints";

import type { LocalizedField } from "./types";

export interface Answer {
  field_key: string;
  label: LocalizedField;
  value: string;
}

interface Entry {
  id: string;
  email: string;
  is_winner: boolean;
  created_at: string;
  answers: Answer[];
}

/**
 * Retrieves a user by email and instance.
 * @param email - The user's email.
 * @param instance - The instance.
 * @returns The user entry.
 * @throws If the user is not found or there is an error with the server.
 */
export const getUserByEmail = async (
  email: string,
  instance: string,
): Promise<Entry> => {
  const response = await fetch(
    cincolabdataEndpoints.public.entries(instance, email),
    {
      method: "GET",
      headers: prepareHeaders(),
      mode: "cors",
      redirect: "follow",
    },
  );

  if (response.status === 200) {
    const data = await response.json();
    if (data.length === 0) {
      throw new Error("Sorry we couldn't find that user.");
    }
    return data[0];
  } else {
    throw new Error("Sorry there was an error with the server.");
  }
};
